import React from 'react'
import styles from './Footer.module.css'

const Footer = () => {
  return (
    <footer className={styles.footer}>
        <a href="https://cellnology.jp" className={styles.link}>
          <img src='/images/logo.png' alt='logo'/>
        </a>
        <small>&copy; 2023 CELLNOLOGY Inc.</small>
    </footer>
  )
}

export default Footer